export enum AdminRole {
  Admin = 'Admin',
  SaleManager = 'SaleManager',
  SaleExpert = 'SaleExpert',
  AccountingManager = 'AccountingManager',
  AccountingExpert = 'AccountingExpert',
  WebsiteSupport = 'WebsiteSupport',
  CustomerSupport = 'CustomerSupport',
}

export const MODULE_ACCESS: Record<string, AdminRole[]> = {
  user: [AdminRole.Admin],
  category: [AdminRole.Admin, AdminRole.SaleManager],
  slider: [AdminRole.Admin, AdminRole.WebsiteSupport],
  redirectRules: [AdminRole.Admin, AdminRole.WebsiteSupport],
  staticSitemapEntries: [AdminRole.Admin, AdminRole.WebsiteSupport],
  robotsTxt: [AdminRole.Admin, AdminRole.WebsiteSupport],
  aboutUs: [AdminRole.Admin],
  province: [AdminRole.Admin],
  productAttribute: [AdminRole.Admin, AdminRole.SaleManager],
  product: [
    AdminRole.Admin,
    AdminRole.SaleManager,
    AdminRole.AccountingManager,
  ],
  discount: [
    AdminRole.Admin,
    AdminRole.SaleManager,
    AdminRole.AccountingManager,
  ],
  comment: [
    AdminRole.Admin,
    AdminRole.WebsiteSupport,
    AdminRole.CustomerSupport,
  ],
  promotion: [
    AdminRole.Admin,
    AdminRole.SaleManager,
    AdminRole.SaleExpert,
    AdminRole.AccountingManager,
  ],
  order: [
    AdminRole.Admin,
    AdminRole.SaleManager,
    AdminRole.SaleExpert,
    AdminRole.AccountingManager,
    AdminRole.AccountingExpert,
  ],
  shipment: [
    AdminRole.Admin,
    AdminRole.SaleManager,
    AdminRole.SaleExpert,
    AdminRole.AccountingManager,
    AdminRole.AccountingExpert,
  ],
  shippingInquiry: [
    AdminRole.Admin,
    AdminRole.SaleManager,
    AdminRole.SaleExpert,
  ],
}

export interface SidebarNavItem {
  title: string
  icon: string
  value: string
  link: string
  allowedRoles: AdminRole[]
}

export const SIDEBAR_NAV: SidebarNavItem[] = [
  {
    title: 'کاربران',
    icon: 'users',
    value: 'user',
    link: '/user',
    allowedRoles: MODULE_ACCESS.user,
  },
  {
    title: 'دسته بندی ها',
    icon: 'list',
    value: 'category',
    link: '/category',
    allowedRoles: MODULE_ACCESS.category,
  },
  {
    title: 'اسلایدرها',
    icon: 'houseLine',
    value: 'slider',
    link: '/slider',
    allowedRoles: MODULE_ACCESS.slider,
  },
  {
    title: 'قوانین ریدایرکت',
    icon: 'link',
    value: 'redirectRules',
    link: '/redirect-rules',
    allowedRoles: MODULE_ACCESS.redirectRules,
  },
  {
    title: 'sitemap  ',
    icon: 'linkLinear',
    value: 'staticSitemapEntries',
    link: '/static-sitemap',
    allowedRoles: MODULE_ACCESS.staticSitemapEntries,
  },
  {
    title: 'robots.txt',
    icon: 'fileDocument',
    value: 'robotsTxt',
    link: '/robots-txt',
    allowedRoles: MODULE_ACCESS.robotsTxt,
  },
  {
    title: 'درباره ما',
    icon: 'info',
    value: 'aboutUs',
    link: '/about-us',
    allowedRoles: MODULE_ACCESS.aboutUs,
  },
  {
    title: 'استان ها',
    icon: 'location',
    value: 'province',
    link: '/province',
    allowedRoles: MODULE_ACCESS.province,
  },
  {
    title: 'ویژگی های محصول',
    icon: 'boxInfo',
    value: 'productAttribute',
    link: '/productAttribute',
    allowedRoles: MODULE_ACCESS.productAttribute,
  },
  {
    title: 'محصولات',
    icon: 'box',
    value: 'product',
    link: '/product',
    allowedRoles: MODULE_ACCESS.product,
  },
  {
    title: 'تخفیفات',
    icon: 'discount',
    value: 'discount',
    link: '/discount',
    allowedRoles: MODULE_ACCESS.discount,
  },
  {
    title: 'کامنت‌ها',
    icon: 'chatSlash',
    value: 'comment',
    link: '/comment',
    allowedRoles: MODULE_ACCESS.comment,
  },
  {
    title: 'کمپین فروش',
    icon: 'promotion',
    value: 'promotion',
    link: '/promotion',
    allowedRoles: MODULE_ACCESS.promotion,
  },
  {
    title: 'سفارشات',
    icon: 'list',
    value: 'order',
    link: '/order',
    allowedRoles: MODULE_ACCESS.order,
  },
  {
    title: 'محموله‌ها',
    icon: 'box',
    value: 'shipment',
    link: '/shipment',
    allowedRoles: MODULE_ACCESS.shipment,
  },
  {
    title: 'درخواست‌های حمل باربری',
    icon: 'location',
    value: 'shippingInquiry',
    link: '/shipping-inquiry',
    allowedRoles: MODULE_ACCESS.shippingInquiry,
  },
]
